import { render, staticRenderFns } from "./ReportsDeliveryIssueView.vue?vue&type=template&id=0fc29b32"
import script from "./ReportsDeliveryIssueView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryIssueView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports